import { Component } from '@angular/core';
import { AuthService } from '@authentication/auth.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-tableros-index',
  templateUrl: './tableros-index.component.html',
  styleUrls: ['./tableros-index.component.scss']
})
export class TablerosIndexComponent {

  TipoUsuario = TipoUsuario;

  constructor(private authService: AuthService) { }

  hasRole(...roles: TipoUsuario[]) {
    return this.authService.hasRole(...roles);
  }

}
